import { useState } from 'react';
let id = 0;
function generateId() {
    return String(++id);
}
/**
 * Cheap id generator. Usefully for generating element ids when dealing with a11y.
 *
 * @param providedId a fallback id to use instead of generation
 * @returns {String} id
 */
function useId(providedId) {
    let [id, setId] = useState(providedId);
    if (id === undefined || id === null) {
        setId(generateId());
    }
    return providedId ?? id ?? undefined;
}
export { useId };
